import React, {useEffect} from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {getPartnersCard, setCabinetPartnersCardEditModalStatus} from "../../../store/cabinet/action";


const CabinetPartnersContactCard = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const partnersCard = useSelector(store => store.cabinet.partnersCard);


    useEffect(() => {
        dispatch(getPartnersCard());
    }, [dispatch])

    return (
        <div className={Styles.container}>
            <div className={Styles.cardImgWrap}>
                <div className={Styles.cardImgWrapItem}>Email: {partnersCard?.card_email || "---"}</div>
                <div className={Styles.cardImgWrapItem}>Name: {partnersCard?.name || "---"}</div>
                <div className={Styles.cardImgWrapItem}>Telegram: {partnersCard?.telegram || "---"}</div>
            </div>
            <div className={Styles.btnWrap}>
                <button
                    type="button"
                    className={Styles.shareBtn}
                    onClick={()=>{}}
                >
                    {t("Поделиться визиткой")}
                </button>
                <button
                    type="button"
                    className={Styles.editBtn}
                    onClick={()=>{dispatch(setCabinetPartnersCardEditModalStatus(true))}}
                >
                    {t("Редактировать")}
                </button>
            </div>
        </div>
    );
};

export default CabinetPartnersContactCard;